(function () {
	'use strict';

	angular
		.module('wizard-english-test')
		.controller('ChatController', ChatController)

	/** @ngInject */
	function ChatController($timeout, $q, $state, $stateParams, HelperService, NotifyService, AgeGroupsService, EventService, PersonEventService, LeadService, UnitService, APP, sweetAlert) {
		const vm = this;
		let leadData;
		let isEnterKeyPressed = false;
		let endTestMessage = $stateParams.endTestMessage || null;

		vm.submitStep = (data = "") => {
			isEnterKeyPressed = true;

			if (vm.currentStep == 1) {
				if (!vm.leadData || !vm.leadData.firstName || !vm.leadData.firstName.length || vm.leadData.firstName == null) {
					NotifyService.error("Informe seu nome!");
					return;
				}

				if (!vm.leadData || !vm.leadData.lastName || !vm.leadData.lastName.length || vm.leadData.lastName == null) {
					NotifyService.error("Informe seu sobrenome!");
					return;
				}

				vm.leadData.firstName = vm.leadData.firstName.split(" ")[0];
				vm.leadData.lastName = vm.leadData.lastName;

				renderMessages([{
					message: 'Meu nome é ' + vm.leadData.firstName.charAt(0).toUpperCase() + vm.leadData.firstName.slice(1),
					type: 'user'
				}]);

				endStep();
				return;
			}

			if (vm.currentStep == 11) {
				if (!vm.leadData || !vm.leadData.document || !vm.leadData.document.length || vm.leadData.document == null) {
					NotifyService.error("Informe seu cpf!");
					return;
				}

				getPersonEventByCode(vm.leadData.document.replace(/\D/g, '')).then(
					success => {
						let finderDoc = vm.eventPersonData;

						if (!finderDoc) {
							NotifyService.error("Não encontrei esse cpf em nossa base. Verifique se digitou corretamente e tente novamente!");
							return;
						}

						var parts = finderDoc.Name.trim().split(" ");

						vm.leadData.firstName = parts[0];
						vm.leadData.lastName = parts.slice(1).join(" ");

						vm.leadData.email = finderDoc.Email;
						vm.leadData.eventId = finderDoc.EventId;
						vm.leadData.phone = finderDoc.Phone;

						renderMessages([{
							message: 'Meu cpf é ' + vm.leadData.document.slice(0, 3) + '.***.***-**',
							type: 'user'
						}]);

						endStep();
					}, error => {
						NotifyService.error("Não encontrei esse cpf em nossa base. Verifique se digitou corretamente e tente novamente!");
					}
				)

				return;
			}

			if (vm.currentStep == 2) {
				if (!data || data == null) {
					NotifyService.error("Selecione uma faixa etária!");
					return;
				}

				vm.leadData.ageGroup = vm.ageGroups.find(el => el.Id == data);

				renderMessages([{
					message: vm.leadData.ageGroup.Description,
					type: 'user'
				}]);

				endStep();
				return;
			}

			if (vm.currentStep == 3) {
				if (vm.event == null) {
					if (!data || data == null) {
						NotifyService.error("Informe se você já é aluno Wizard!");
						return;
					}

					vm.leadData.isStudent = data;

					renderMessages([{
						message: vm.leadData.isStudent,
						type: 'user'
					}]);
				}

				endStep();
				return;
			}

			if (vm.currentStep == 4) {

				if (vm.event === null) {

					if (!vm.leadData || !vm.leadData.email || !vm.leadData.email.length || vm.leadData.email == null) {
						NotifyService.error("Informe seu e-mail!");
						return;
					}

					renderMessages([{
						message: 'Meu e-mail é ' + vm.leadData.email,
						type: 'user'
					}]);
				}

				endStep();
				return;
			}

			if (vm.currentStep == 5) {
				postLead()
			}

			if (vm.currentStep == 6) {
				if (!data || data == null) {
					NotifyService.error("Selecione uma opção!");
					return;
				}

				leadData.Accepted = (data == "Sim") ? true : false;
				vm.leadData.Accepted = (data == "Sim") ? true : false;

				renderMessages([{
					message: (data == "Sim") ? "Quero conhecer!" : "Não tenho interesse",
					type: 'user'
				}]);

				let endTest = (leadData.Accepted == true) ? false : true;
				endStep(endTest);

				return;
			}

			if (vm.currentStep == 7) {

				if (leadData.Event === null) {
					if (!vm.leadData || !vm.leadData.phone || !vm.leadData.phone.length || vm.leadData.phone == null) {
						NotifyService.error("Informe seu telefone com DDD!");
						return;
					}

					renderMessages([{
						message: 'Meu telefone é ' + vm.leadData.phone,
						type: 'user'
					}]);

					leadData.phone = vm.leadData.phone;
				}

				endStep();
				return;
			}

			if (vm.currentStep == 8) {

				if (leadData.Event === null) {
					if (!vm.leadData.unit || vm.leadData.unit == null || !vm.leadData.unit.dc) {
						NotifyService.error("Selecione a unidade mais próxima de você!");
						return;
					}
				}

				postLead(true)
			}
		}

		vm.onChangeUnitState = () => {
			if (vm.leadData.state.Name == "-1" || vm.leadData.state.Name == null || vm.leadData.state.Name == undefined || vm.leadData.state.Name == "") return;

			vm.cityOptions = [{ Name: "AGUARDE..." }];
			vm.unitOptions = [{ shortName: "AGUARDE..." }];

			getUnitCities(vm.leadData.state.Id);
		}

		vm.onChangeUnitCity = () => {
			if (vm.leadData.city.Name == "-1" || vm.leadData.city.Name == null || vm.leadData.city.Name == undefined || vm.leadData.city.Name == "") return;

			vm.unitOptions = [{ shortName: "AGUARDE..." }];

			getUnits(vm.leadData.city.Id);
		}

		vm.retryTest = () => {

			let event = (leadData && leadData.Event) ? leadData.Event : null;

			finishTest();

			if (event) {
				$state.go("app.event", { url: event });
			} else {
				$state.go("app.home");
			}
		}

		init();

		function getLocalLeadData() {
			leadData = HelperService.getFromLocalStorage(APP.LEAD_LOCAL_DATA);

			$timeout(() => {
				vm.leadData = angular.copy(leadData);
			}, 1)

		}

		function postLead(isPut = false) {
			HelperService.startLoading("#chat", "Enviando seus dados...");

			let leadPostData = {};

			if (isPut == true) {
				leadPostData = {};

				leadPostData.IsFinished = true;

				delete leadPostData.phone;

				leadPostData.Accepted = (vm.leadData.Accepted == true) ? "Sim" : "Não";

				if (vm.leadData.unit && vm.leadData.unit.dc)
					leadPostData.UnitCode = vm.leadData.unit.dc.replace("DC", "11");

				if (vm.leadData.state && vm.leadData.state.Name != "AGUARDE...")
					leadPostData.State = vm.leadData.state.Name;

				if (vm.leadData.city && vm.leadData.city.Name != "AGUARDE...")
					leadPostData.City = vm.leadData.city.Name;

				if (vm.leadData.phone)
					leadPostData.Phone = vm.leadData.phone.replace(/\D/g, '');

				if (vm.leadData.Code && vm.leadData.Code != "AGUARDE...")
					leadPostData.Code = vm.leadData.Code;
			} else {
				leadPostData.Name = vm.leadData.firstName;
				leadPostData.LastName = vm.leadData.lastName;
				leadPostData.Email = vm.leadData.email;
				leadPostData.AgeGroupId = vm.leadData.ageGroup.Id;
				leadPostData.EventId = vm.leadData.eventId;
				leadPostData.Phone = vm.leadData.phone;
			}

			let urlQueries = sessionStorage.getItem('urlQueries');
			let qsMidia = sessionStorage.getItem('qsMidia');

			if (urlQueries) {
				leadPostData.MediaName = urlQueries;
				sessionStorage.setItem('urlQueries', '');
			}

			if (qsMidia) {
				leadPostData.MediaId = qsMidia;
				sessionStorage.setItem('qsMidia', '');
			}

			if (isPut == true) {
				LeadService
					.put(leadPostData)
					.then(
						success => {
							HelperService.stopLoading("#chat");

							if (success.Code) {
								leadUpdatedSuccessCallback(success)
							}
							else
								HelperService.errorCallback(success)

							return;
						}, error => {
							HelperService.stopLoading("#chat");
							HelperService.errorCallback(error)
						}
					)
			} else {
				LeadService
					.post(leadPostData)
					.then(
						success => {
							HelperService.stopLoading("#chat");

							if (success.Code)
								leadSavedSuccessCallback(success);
							else
								HelperService.errorCallback(success)

							return;
						}, error => {
							HelperService.stopLoading("#chat");
							HelperService.errorCallback(error)
						}
					)
			}
		}

		function leadUpdatedSuccessCallback(data) {
			if (vm.leadData.IsStudent)
				finishTest();
			else {
				if (vm.leadData.unit) {
					renderMessages([{
						message: 'Cidade de ' + data.City + ', unidade ' + vm.leadData.unit.shortName,
						type: 'user'
					}]);
				}

				endStep();
			}
		}

		function leadSavedSuccessCallback(data) {
			HelperService.saveToLocalStorage(APP.LEAD_LOCAL_DATA, {
				Name: data.Name,
				Code: data.Code,
				Email: data.Email,
				Event: vm.event,
				AgeGroupId: data.AgeGroupId,
				Accepted: data.Accepted,
				IsStudent: (vm.leadData.isStudent == "Sim") ? true : false
			});

			$state.go("app.quiz");
		}

		function finishTest() {
			leadData = null;
			HelperService.removeFromLocalStorage(APP.LEAD_LOCAL_DATA);
		}

		function onChangeStep() {
			let stepMessages = [];

			if (vm.currentStep == 1) {
				stepMessages = [
					{
						message: 'Oi, eu sou a Wizzy aqui da Wizard! Que legal que você quer testar seu inglês com a gente! &#128540;',
						type: 'system'
					},
					{
						message: 'Me conta, qual é o seu nome?',
						type: 'system'
					}
				];
			}

			if (vm.currentStep == 11) {
				stepMessages = [
					{
						message: 'Oi, eu sou a Wizzy aqui da Wizard! Que legal que você quer testar seu inglês com a gente! &#128540;',
						type: 'system'
					},
					{
						message: 'Qual seu cpf?',
						type: 'system'
					}
				];
			}

			if (vm.currentStep == 2) {
				stepMessages = [
					{
						message: 'Qual sua idade?',
						type: 'system'
					},
				];
			}

			if (vm.currentStep == 3) {

				if (vm.leadData.ageGroup.Id == 1) {
					stepMessages = [
						{
							message: 'Oi, ' + vm.leadData.firstName + '!',
							type: 'kids'
						},
						{
							message: 'Que legal que você se interessa por inglês!',
							type: 'kids'
						},
						{
							message: 'Esse teste aqui não pode ser feito por menores de 12 anos...',
							type: 'kids'
						},
						{
							message: 'Mas vou te mostrar alguns vídeos da minha turminha pra você conhecer mais sobre a Wizkids!',
							type: 'kids'
						},
						{
							message: 'Você pode pedir para o seu responsável se informar sobre nossos cursos pra crianças no site da Wizard, ok?',
							type: 'kids'
						}
					];

					renderMessages(stepMessages).then(() => {
						endStepKids();
					});
					return
				} else {
					stepMessages = [
						{
							message: 'Legal, ' + vm.leadData.firstName.charAt(0).toUpperCase() + vm.leadData.firstName.slice(1) + '!',
							type: 'system'
						},
						{
							message: 'Você já estuda na Wizard?',
							type: 'system'
						},
					];
				}

			}

			if (vm.currentStep == 4) {
				if (vm.event === null) {
					stepMessages = [
						{
							message: 'Entendi.',
							type: 'system'
						},
						{
							message: 'Preciso do seu email para enviar seu resultado ao fim do teste &#x1F609;',
							type: 'system'
						},
					];
				}
			}

			if (vm.currentStep == 5) {
				stepMessages = [
					{
						message: vm.leadData.firstName + ', o teste tem duração aproximada de 15 à 30 minutos. &#128339;',
						type: 'system'
					},
					{
						message: 'Algumas questões podem ter áudio, então procure um lugar tranquilo para respondê-las.',
						type: 'system'
					},
					{
						message: 'Ah! Se preciso, lembre-se de usar fones &#127911;. Beleza? ',
						type: 'system'
					},
				];
			}

			// Após encerrar o teste
			if (vm.currentStep == 6) {

				if (leadData.Event != null) {
					if (endTestMessage != null) {
						stepMessages = [
							{
								message: endTestMessage,
								type: 'system'
							},
							{
								message: 'Obrigado por participar do nosso teste de inglês! &#128522;',
								type: 'system'
							},
							{
								message: 'Em breve, nossa equipe entrará em contato para compartilhar seus resultados e orientar os próximos passos.',
								type: 'system'
							}
						];

						console.log('vm.event', vm.event);
						console.log('vm.eventData', vm.eventData);
					} else {
						stepMessages = [
							{
								message: 'Já estou com seus resultados, ' + leadData.Name + '! &#128540;',
								type: 'system'
							}
						];
					}
					finishTest();
					endStep(true, false);
				} else {
					if (endTestMessage != null) {
						stepMessages = [
							{
								message: endTestMessage,
								type: 'system'
							},
							{
								message: 'Já estou com seus resultados! &#128540; Vou enviar para você por email.',
								type: 'system'
							}
						];
					} else {
						stepMessages = [
							{
								message: 'Já estou com seus resultados, ' + leadData.Name + '! &#128540; Vou enviar para você por email.',
								type: 'system'
							}
						];
					}

					if (leadData.IsStudent == false) {
						stepMessages = stepMessages.concat([
							{
								message: 'Mas antes, que tal conhecer mais sobre a nossa metodologia de ensino?',
								type: 'system'
							},
							{
								message: 'Você aceita receber o contato da Wizard?',
								type: 'system'
							}
						]);

					} else if (leadData.IsStudent == true) {
						stepMessages = stepMessages.concat([
							{
								message: 'Te espero na Wizard para continuar aprimorando seu inglês! &#129392;',
								type: 'system'
							}
						]);

						postLead(true);
					}
				}
			}

			if (vm.currentStep == 7) {
				if (vm.leadData.Accepted) {
					stepMessages = [
						{
							message: 'Legal! Preciso do seu telefone com DDD.',
							type: 'system'
						}
					];
				} else {
					stepMessages = [
						{
							message: 'Te espero na Wizard para continuar aprimorando seu inglês! &#129392;',
							type: 'system'
						}
					];
				}
			}

			if (vm.currentStep == 8) {
				stepMessages = [
					{
						message: 'Anotado!',
						type: 'system'
					},
					{
						message: 'Também preciso que você me informe a unidade Wizard mais próxima.',
						type: 'system'
					},
				];
			}

			if (vm.currentStep == 9) {

				if (vm.leadData && vm.leadData.Accepted) {
					stepMessages = [
						{
							message: 'Logo, logo você vai receber o contato da unidade escolhida.',
							type: 'system'
						},
						{
							message: 'Ah, e seus resultados vão chegar por email!',
							type: 'system'
						},
						{
							message: 'Te espero na Wizard para continuar aprimorando seu inglês! &#129392;',
							type: 'system'
						},
					];
				} else {
					stepMessages = [
						{
							message: 'Te espero na Wizard para continuar aprimorando seu inglês! &#129392;',
							type: 'system'
						}
					];
				}

				finishTest();
			}

			renderMessages(stepMessages).then(() => openUserInput());
		}

		function endStep(endTest = false, isPut = true) {
			closeUserInput();

			$timeout(() => {
				if (endTest) {
					vm.currentStep = 9;

					if (isPut)
						postLead(true); // O postLead quando recebe um put, sempre finaliza o teste na sequência, pois o lead só é atualizado ao final do teste.
				} else {
					vm.currentStep = (vm.currentStep === 11) ? 2 : vm.currentStep + 1;
				}

				if (vm.event !== null && (vm.currentStep === 3 && vm.leadData.ageGroup.Id !== 1)) {
					vm.currentStep = 5;
				}

				if (vm.event !== null && (vm.currentStep === 4 || vm.currentStep === 7 || vm.currentStep === 8)) {
					vm.currentStep = vm.currentStep + 1; // Pula o input de email caso seja evento
				}

				onChangeStep();

			}, 600)
		}

		function endStepKids() {
			closeUserInput();
			vm.currentStep = 10;

			$timeout(() => {
				finishTest();
				openUserInput();
				onChangeStep();
				return;
			}, 600)
		}

		function renderMessages(messageGroupArray) {
			vm.isWriting = true;

			return $q(function (resolve, reject) {
				messageGroupArray.forEach((message, index) => {
					$timeout(() => {
						vm.stepMessages = vm.stepMessages.concat(message);

						if (index == (messageGroupArray.length - 1)) {
							vm.isWriting = false;
							resolve(true);
							scrollToEndOfChat();
						}
					}, (index + 1) * 1000)
				});
			});
		}

		function scrollToEndOfChat() {
			$timeout(() => {
				$('#chat-container').animate({
					scrollTop: $('#chat-container')[0].scrollHeight + 15
				}, 1000);
			}, 1000);
		}

		function getUnitStates() {
			return UnitService
				.getUnitStates()
				.then(
					success => {
						vm.stateOptions = success;
						vm.stateOptions.unshift({ Name: "ESTADO", Disabled: true, Selected: true });

						vm.cityOptions = [{ Name: "CIDADE", Disabled: true, Selected: true }];
						vm.unitOptions = [{ shortName: "UNIDADE", Disabled: true, Selected: true }];

						vm.leadData.state = vm.stateOptions[0];
						vm.leadData.city = vm.cityOptions[0];
						vm.leadData.unit = vm.unitOptions[0];
					}, error => {
						HelperService.errorCallback(error)
					}
				)
		}

		function getUnitCities(stateId) {
			UnitService
				.getUnitCities(stateId)
				.then(
					success => {
						vm.cityOptions = success;
						vm.cityOptions.unshift({ Name: "CIDADE", Disabled: true, Selected: true });

						vm.unitOptions = [{ shortName: "UNIDADE", Disabled: true, Selected: true }];

						vm.leadData.city = vm.cityOptions[0];
						vm.leadData.unit = vm.unitOptions[0];
					},
					error => HelperService.errorCallback(error)
				)
		}

		function getUnits(cityId) {
			UnitService
				.getUnits(cityId)
				.then(
					success => {
						vm.unitOptions = success;
						vm.unitOptions.unshift({ shortName: "UNIDADE", Disabled: true, Selected: true });
						vm.leadData.unit = vm.unitOptions[0];

						if (localStorage.getItem('setTeste') == 'true') {
							vm.unitOptions.push({ shortName: "CADASTRO TESTE E-COM", customerCode: 41278, Disabled: false, Selected: false });
						}
					},
					error => HelperService.errorCallback(error)
				)
		}

		function openUserInput() {
			$timeout(() => {
				if (vm.currentStep == 1 || vm.currentStep == 11 || vm.currentStep == 4 || vm.currentStep == 7) {
					vm.showUserInput = true;
					$timeout(() => document.getElementById("userInputText").focus(), 1);
					isEnterKeyPressed = false;
					return
				}

				if (vm.currentStep == 2 ||
					vm.currentStep == 3 ||
					vm.currentStep == 5 ||
					vm.currentStep == 6 ||
					vm.currentStep == 9 ||
					vm.currentStep == 10) {

					vm.showUserInput = true;
					return
				}

				if (vm.currentStep == 8) {
					HelperService.startLoading("#chat", "Listando unidades");

					getUnitStates()
						.then(
							success => {
								HelperService.stopLoading("#chat");
								vm.showUserInput = true;
							},
							error => {
								HelperService.stopLoading("#chat");
								HelperService.errorCallback(error);
							}
						)
				}

			}, 1000)
		}

		function closeUserInput() {
			vm.showUserInput = false;
		}

		function getAgeGoups() {
			return AgeGroupsService
				.getAgeGoups()
				.then(
					success => {
						vm.ageGroups = success;
					}, error => {
						HelperService.retryCallback(error, getAgeGoups);
					}
				)
		}

		function initVars() {
			vm.stepMessages = [];
			vm.leadData = {};
			vm.showUserInput = false;
			vm.isWriting = false;
			vm.ageGroup = [];
		}

		function getEventByUrl(url) {
			return EventService
				.getEventByUrl(url)
				.then(
					success => {
						vm.eventData = success;
					}, error => {
						HelperService.retryCallback(error, getEventByUrl);
					}
				)
		}

		function getPersonEventByCode(cpf) {
			HelperService.startLoading("#chat");

			return PersonEventService
				.getEventByCode(cpf)
				.then(
					success => {
						HelperService.stopLoading("#chat");
						vm.eventPersonData = success;
					}, error => {
						HelperService.stopLoading("#chat");
						HelperService.retryCallback(error, getPersonEventByEventId);
					}
				)
		}

		function init() {
			let currentStateName = $state.current.name;
			let initActions = [
				getAgeGoups()
			]
			vm.event = null;

			if (currentStateName === "app.event") {
				vm.event = $stateParams.url;

				initActions.push(getEventByUrl(vm.event));
			}

			HelperService.startLoading("#chat");

			initVars();
			getLocalLeadData();

			if (leadData && leadData.IsFinished == true && currentStateName == "app.chat") {
				$state.go("app.result", {
					endTestMessage: endTestMessage
				});
			} else if (leadData && leadData.IsFinished == true) {
				HelperService.stopLoading("#chat");
				vm.leadData = leadData;
				vm.leadData.firstName = vm.leadData.Name.split(" ")[0];
				vm.currentStep = 6;
				vm.stateOptions = [{ Name: "AGUARDE..." }];
				vm.cityOptions = [{ Name: "AGUARDE..." }];
				vm.unitOptions = [{ shortName: "AGUARDE..." }];

				// vm.leadData.state = vm.stateOptions[0];
				// vm.leadData.city = vm.cityOptions[0];
				// vm.leadData.unit = vm.unitOptions[0];

				onChangeStep();
			} else {
				if (currentStateName == "app.result" && !leadData)
					$state.go("app.chat");

				$q.all(initActions).then(
					success => {
						HelperService.stopLoading("#chat");

						if (currentStateName === "app.event") {
							if (!vm.eventData) {
								$state.go("app.not-found");
								return;
							} else {
								vm.currentStep = 11;

								onChangeStep();
								return;
							}
						}

						if (success && vm.ageGroups.length) {
							vm.currentStep = 1;

							onChangeStep();
						}
					}, error => {
						HelperService.stopLoading("#chat");
						HelperService.errorCallback(error);
					}
				)
			}
		}
	}
}());